import { CreditAcceptResponse } from '../../../domain/creditCard'
import { CreditApr } from '../../../domain/creditApplication'
import {
  CreditApplicationError,
  PROCESSING_SCREEN
} from '../ApplicationSubmitted/types'
import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'
import { PromotionOverrides } from '../../../domain/config'

export type ApplicationReadyProps = {
  applicationId: string
  setCardSubmitted: (data: CreditAcceptResponse) => void
  handleError: (error: CreditApplicationError) => void
}

type CreditOffer = CreditApr & {
  limit: number
}

export type ApplicationReadyComponentProps = {
  creditOffer?: CreditOffer
  riskBasedPricingDoc?: string
  onDeclineOffer(): void
  onAcceptOffer(): Promise<void>
  loading: boolean
  decliningOffer: boolean
  promotionOverride: PromotionOverrides | null
}

export type RiskBasedPricingDoc = {
  fileName: string
  fileType: string
  fileBase64String: string
}

export const RISK_BASED_PRICING_NOTICE = 'risk-based-pricing-notice'

export const PROGRAM_TERMS_URL =
  'https://dq1xxrax08ia8.cloudfront.net/card/legal/2022/02/01/Paceline%20Consumer%20Credit%20Card%20Application%20Terms%20and%20Conditions.pdf'

export const CASH_PROGRAM_TERMS_URL =
  'https://dq1xxrax08ia8.cloudfront.net/card/legal/2022/02/01/Paceline%20Cash%20Rewards%20Program%20Terms%20and%20Conditions.pdf'

export const MERCHANT_LIST_URL =
  'https://paceline.zendesk.com/hc/en-us/articles/4404216434580-What-qualifies-as-a-Health-Wellness-purchase-'

export const PL_PRIVACY_POLICY_URL =
  'https://dq1xxrax08ia8.cloudfront.net/card/legal/Consumer%20Privacy%20Policy%20Notice%20-%209.15.20%20Final.2.pdf'

export const OFFER_TERMS_URL =
  'https://dq1xxrax08ia8.cloudfront.net/card/legal/2022/07/20/Paceline%20Qualifying%20Fitness%20Device%20Purchase%20Reimbursement%20Terms%20and%20Conditions.pdf'

export const APPLICATION_PREAPPROVED_SCREEN = 'preApproved'

export const PreApprovedScreenEvent: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  heading: 'Congratulations!',
  screen: APPLICATION_PREAPPROVED_SCREEN,
  from_screen: PROCESSING_SCREEN
}

export const AcceptButtonEvent: ButtonTracking = {
  asset_id: 'acceptButton',
  screen: APPLICATION_PREAPPROVED_SCREEN,
  asset_text: 'ACCEPT OFFER'
}

export const DeclineOfferButtonEvent: ButtonTracking = {
  asset_id: 'declineButton',
  asset_text: 'DECLINE OFFER',
  screen: APPLICATION_PREAPPROVED_SCREEN
}
